export default {
  massRemove: 'Remove resolve rules',
  massEnable: 'Enable resolve rules',
  massDisable: 'Disable resolve rules',
  removeForbidden: '{name} cannot be deleted.',
  disableForbidden: '{name} cannot be disabled.',
};
